import { HeaderMenus as HeaderMenusES } from './header';
import { FooterMenu as FooterMenuES, FooterCopyRightLinks as FooterCopyRightLinksES } from './footer';
import { GlobalNavigationConfig } from '../../../entities';

export const SpainConfig: GlobalNavigationConfig = {
  footerVariant: 'simple',
  headerVariant: 'simple',
  logoVariant: 'spain',
  menu: {
    copyright: FooterCopyRightLinksES,
    footer: FooterMenuES,
    header: HeaderMenusES,
  },
};
